
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { AgeGroupVariationFormData } from "../schemas/ageGroupVariationSchema";
import { MinAgeSection } from './MinAgeSection';
import { MaxAgeSection } from './MaxAgeSection';
import { GradeOption } from '../hooks/useAgeGroupVariationForm';

interface AgeGroupFieldsProps {
  form: UseFormReturn<AgeGroupVariationFormData>;
  gradeOptions: GradeOption[];
}

export const AgeGroupFields: React.FC<AgeGroupFieldsProps> = ({
  form,
  gradeOptions
}) => {
  return (
    <div className="grid grid-cols-2 gap-8">
      <MinAgeSection form={form} gradeOptions={gradeOptions} />
      <MaxAgeSection form={form} gradeOptions={gradeOptions} />
    </div>
  );
};
